import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <Section tone="cream" data-id="element-313" data-mp="3r78y7qpzusw9">
      <Eyebrow data-id="element-314" data-mp="3r8kc4jd5lh13">Lo que dicen otros médicos</Eyebrow>
      <Heading data-id="element-315" data-mp="3r9byr4orw4f8">Médicos que ya decidieron con el sistema</Heading>

      <div className="mt-8 space-y-4" data-id="element-316" data-mp="obgj6z2751">
        {testimonials.map((testimonial, i) => <motion.figure key={testimonial.name} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.45,
        ease: 'easeOut',
        delay: i * 0.06
      }} className="rounded-3xl border border-navy/10 bg-white p-4 sm:p-6" data-id="element-317" data-mp="41hy798ohfwc" data-mpi={i}>
            <QuoteIcon className="h-6 w-6 text-brand/25" aria-hidden="true" data-id="element-318" data-mp="2fru2srdfo939" />
            <blockquote className="mt-2 text-balance text-[15px] font-semibold leading-relaxed text-navy sm:text-[17px]" data-id="element-319" data-mp="1slkq3bo9z6hg">
              “{testimonial.quote}”
            </blockquote>

            <figcaption className="mt-4 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-320" data-mp="1iu7vwdf08489">
              <img src={testimonial.image} alt={`Fotografía de ${testimonial.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand/20" loading="lazy" data-id="element-321" data-mp="1eto1hhltfept" />
              <div className="min-w-0" data-id="element-322" data-mp="26i7mndcbfumu">
                <p className="truncate text-[14.5px] font-extrabold text-navy" data-id="element-323" data-mp="22i78ltt4plgb">{testimonial.name}</p>
                <p className="text-[12.5px] font-semibold text-navy/55" data-id="element-324" data-mp="1xk5jar540pwe">
                  {testimonial.location} {testimonial.flag}
                </p>
                <div className="mt-1 flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-325" data-mp="r1gyhzll49hf">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-326" data-mp="nlcq24hig4ew" data-mpi={index} />)}
                </div>
              </div>
            </figcaption>
          </motion.figure>)}
      </div>

      <SectionCTA promise="Únete a los más de 2.000 médicos que ya no improvisan en consulta." label="Quiero los mismos resultados" data-id="element-327" data-mp="il8bwl42rlru" />
    </Section>;
}